<template>
  <article
    class="flex flex-col justify-center w-full shadow-xl rounded-xl transform"
    :class="{ 'transition duration-700 hover:scale-105 delay-100 cursor-pointer': !locked }"
  >
    <header class="h-64 w-full rounded-xl">
      <CreateContentOverlay v-if="locked === true" />

      <img class="w-full h-full object-cover rounded-t-xl" :src="campaign.imageUrl" />

      <div
        class="absolute rounded-full w-16 h-16 lg:w-20 lg:h-20 bg-white border-2 border-gray-200 -mt-8 lg:-mt-10 mx-4 mb-6 p-1"
      >
        <img
          class="w-full h-full object-contain rounded-full z-10"
          src="https://storage.googleapis.com/files.creators.adoreme.com/production/hxQChNao7Ln0QkY1yWqbgxItyT4iAcaDU0VEPZke.png"
        />
      </div>
    </header>

    <section class="pt-8 lg:pt-10 px-8">
      <h1 class="text-primary text-2xl">{{ campaign.title }}</h1>
    </section>

    <footer class="px-8 pb-8 pt-2">
      <div v-if="!campaign.application" class="flex items-center">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          stroke-width="1.5"
          stroke="currentColor"
          class="w-6 h-6 mr-1 text-black"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            d="M12 6v12m-3-2.818l.879.659c1.171.879 3.07.879 4.242 0 1.172-.879 1.172-2.303 0-3.182C13.536 12.219 12.768 12 12 12c-.725 0-1.45-.22-2.003-.659-1.106-.879-1.106-2.303 0-3.182s2.9-.879 4.006 0l.415.33M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
          />
        </svg>

        <h2 v-if="campaign.isIntro" class="font-semibold text-sm lg:text-md text-black">
          Complete to unlock the paid tasks
        </h2>
        <div v-else class="flex text-black">
          <h2 class="font-semibold text-sm lg:text-md">Rewards:&nbsp;</h2>
          <p class="font-bold text-sm lg:text-md">${{ campaign.flat_rate }}</p>
        </div>
      </div>
      <p v-else class="font-semibold text-sm lg:text-md text-black">{{ applicationPrettyStatus }}</p>
    </footer>
  </article>
</template>

<script>
import CreateContentOverlay from './CreateContentOverlay.vue';

export default {
  name: 'CreateContentTaskCard',
  components: { CreateContentOverlay },
  props: ['campaign', 'locked'],
  computed: {
    applicationPrettyStatus() {
      switch (this.campaign?.application?.status) {
        case 'pending_approval':
          return 'Your application is being reviewed ⏳';
        case 'waiting_for_content':
          return 'Waiting for you to upload content ⏳';
        case 'review_content':
          return 'Your content is being reviewed ⏳';
        default:
          return '';
      }
    },
  },
};
</script>
